import { render, staticRenderFns } from "./JImagePreview.vue?vue&type=template&id=39d1a1ee"
import script from "./JImagePreview.vue?vue&type=script&lang=js"
export * from "./JImagePreview.vue?vue&type=script&lang=js"
import style0 from "./JImagePreview.vue?vue&type=style&index=0&id=39d1a1ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports